export default "__VITE_ASSET__0e8ccb20__"